<div [class.markdown-regular-wrapper]="!shortEditor"
     [class.markdown-short-wrapper]="shortEditor">
  <textarea [id]="id" type="text" class="form-control" rows="5"
            [(ngModel)]="content"></textarea>
</div>
